// Autoplay videos rendered with a poster image stay hidden until they play.
// When autoplay is blocked (iOS Low Power Mode, data saver), they stay hidden and the poster shows.
function revealWhenPlaying(video) {
    if (video.dataset.revealBound) return;
    video.dataset.revealBound = 'true';

    const show = () => video.classList.add('is-playing');
    if (!video.paused && video.readyState >= 3) show();
    video.addEventListener('playing', show, { once: true });

    // Lazy videos start from the observer below. Hidden breakpoint copies never start.
    if (video.dataset.src || !video.getClientRects().length) return;

    const attempt = video.play();
    if (attempt) attempt.catch(() => video.classList.add('is-blocked'));
}

document.querySelectorAll('video.lazy-video--reveal').forEach(revealWhenPlaying);

// Starts once the page is parsed rather than at the load event, so the on-screen hero video begins
// promptly; off-screen and hidden videos still wait (a hidden breakpoint copy never intersects).
function observeLazyVideos() {
    const videos = document.querySelectorAll('video[data-src]');
    if (!videos.length) return;

    const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
            if (!entry.isIntersecting) return;

            const video = entry.target;
            const src = video.dataset.src;
            if (!src) return;

            video.src = src;
            video.removeAttribute('data-src');
            video.dataset.loaded = 'true';
            video.load();

            if (video.hasAttribute('autoplay')) {
                video.play().catch(err => {
                    video.classList.add('is-blocked');
                    console.warn(err);
                });
            }

            obs.unobserve(video);
        });
    }, { rootMargin: '200px 0px', threshold: 0.01 });

    videos.forEach(video => observer.observe(video));
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeLazyVideos);
} else {
    observeLazyVideos();
}
